import { ISpecGroups } from '../../gqlCommon/model/IVariants';
import modelSpecificationsMap from '../constants/modelSpecificationsMap';
import { useIntl } from 'react-intl';
import { SpecificationCategory } from '../enum/SpecificationCategory';
import {
  GetCarSpecifications_customizeCar_car,
  GetCarSpecifications_customizeCar_car_engine_attributes,
  GetCarSpecifications_customizeCar_car_model_attributes,
} from '../graphql/queries/__generated__/GetCarSpecifications';

const modelSpecificationsService = {
  prepareSpecifications(
    attributes:
      | GetCarSpecifications_customizeCar_car_engine_attributes
      | GetCarSpecifications_customizeCar_car_model_attributes,
  ): ISpecGroups[] {
    const specifications: { [key: string]: ISpecGroups } = {};
    const attributeType = attributes.__typename === 'EngineAttributes' ? 'engine' : 'model';

    for (const [key, value] of Object.entries(attributes)) {
      if (value) {
        const { category, translationKey } = modelSpecificationsMap[attributeType][key] || {};

        if (category) {
          if (!specifications[category]) {
            specifications[category] = {
              name: category,
              specItems: [],
            };
          }

          specifications[category].specItems.push({
            name: translationKey || value,
            value: translationKey ? value : '',
          });
        }
      }
    }

    return Object.values(specifications);
  },

  getModelSpecifications(car: GetCarSpecifications_customizeCar_car): ISpecGroups[] {
    const intl = useIntl();
    const {
      engine: { attributes: engineAttributes },
      model: { attributes: modelAttributes },
    } = car;

    const engineSpecs = this.prepareSpecifications({
      ...engineAttributes,
      brand: intl.formatMessage({ id: `trans__configurator__customise_page_full_specs_modal__motor_brand_value` }),
    });
    const modelSpecs = this.prepareSpecifications(modelAttributes);

    return engineSpecs.concat(modelSpecs);
  },
  orderSpecifications: (specifications: ISpecGroups[]) => {
    return Object.values(SpecificationCategory).map(value => {
      return specifications.find(specification => specification.name === value);
    });
  },
};

export default modelSpecificationsService;
